const LocationSearch = ( function() {
  const config = {
    formId: 'location-search',
    endpoint: `${siteInfo.wpApiSettings.ll}locations/nearest`,
    userLocationEndpoint: `${siteInfo.wpApiSettings.ll}locations/user`,
    userPreferredLocationEndpoint: `${siteInfo.wpApiSettings.ll}preferred-location`,
    nonce: siteInfo.wpApiSettings.nonce,
    limit: 10,
    radius: 100,
    storageKey: 'browns_preferred_location',
  };

  function init() {
    const forms = document.querySelectorAll( `form:has([name="${config.formId}"])` );

    if ( forms.length === 0 ) {
      return;
    }

    forms.forEach( ( form ) => {
      form.addEventListener( 'submit', handleFormSubmit );
    } );

    const useLocationBtn = document.querySelector( 'a[href="#"].group\\/location' );
    if ( useLocationBtn ) {
      useLocationBtn.addEventListener( 'click', handleUseMyLocation );
    }

    document.addEventListener( 'change', function( event ) {
      if ( event.target.name === 'location' && event.target.type === 'radio' ) {
        savePreferredLocation( event.target.value );
      }
    } );

    $( document ).on( 'updated_checkout updated_cart_totals', () => {
      const locationData = getPreferredLocation();
      if ( !locationData ) return;

      document.querySelectorAll( '#shipping_method label' ).forEach( ( label ) => {
        if ( label.innerText.startsWith( 'Pick Up' ) ) {
          label.innerText = `Pick Up in ${locationData.city}`;
        }
      } );
    } );

    initializeLocation();
  }

  function initializeLocation() {
    const storedLocation = getPreferredLocation();

    if ( storedLocation ) {
      selectStoredLocation( storedLocation );
    } else {
      navigator.permissions.query( {name: 'geolocation'} ).then( function( result ) {
        if ( result.state === 'granted' ) {
          handleUseMyLocation();
        } else {
          getLocationByIp();
        }
      } );
    }
  }

  function getLocationByIp() {
    fetch( config.userLocationEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-WP-Nonce': config.nonce,
      },
    } )
        .then( ( response ) => {
          if ( !response.ok ) {
            throw new Error( response.message );
          }
          return response.json();
        } )
        .then( ( data ) => {
          if ( data.success && data.zip ) {
            searchLocations( data.zip );
          }
        } )
        .catch( ( error ) => {
          displayError( error );
        } );
  }

  function savePreferredLocation( locationId ) {
    if ( !locationId ) return;

    try {
      const locationElement = document.querySelector( `input[name="location"][value="${locationId}"]` );
      if ( !locationElement ) return;

      const listItem = locationElement.closest( 'li' );
      if ( !listItem ) return;

      const locationData = {
        id: locationId,
        store_code: listItem.dataset.store_id,
        city: listItem.dataset.city,
        state: listItem.dataset.state,
        zip: listItem.dataset.zip,
        street: listItem.dataset.address,
        timestamp: new Date().getTime(),
      };

      localStorage.setItem( config.storageKey, JSON.stringify( locationData ) );
      getPreferredLocation();
      window.dispatchEvent( new CustomEvent( 'preferredLocationChanged', {
        detail: locationData,
      } ) );

      fetch( config.userPreferredLocationEndpoint, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': config.nonce,
        },
        body: JSON.stringify( locationData ),
      } ).then( () => {
        $( document.body ).trigger( 'update_checkout' );
      } );
    } catch ( error ) {
      console.error( 'Error saving preferred location:', error );
    }
  }

  function getPreferredLocation() {
    try {
      const storedData = localStorage.getItem( config.storageKey );
      if ( !storedData ) return null;

      const locationData = JSON.parse( storedData );
      const now = new Date().getTime();
      const yearInMs = 365 * 24 * 60 * 60 * 1000;

      if ( locationData.timestamp && ( now - locationData.timestamp ) > yearInMs ) {
        localStorage.removeItem( config.storageKey );
        return null;
      }

      document.querySelectorAll( '.js-selected-location' ).forEach( ( element ) => {
        element.innerText = `${locationData.city}`;
      } );

      document.querySelectorAll( '.js-selected-location-value' ).forEach( ( element ) => {
        element.value = `${locationData.store_code}`;
      } );

      document.querySelectorAll( '#shipping_method label' ).forEach( ( label ) => {
        if ( label.innerText.startsWith( 'Pick Up' ) ) {
          label.innerText = `Pick Up in ${locationData.city}`;
        }
      } );

      document.querySelectorAll( '.location-select select' ).forEach( ( locationSelect ) => {
        const $option = locationSelect.querySelector( `option[value="${locationData.store_code}"]` );
        if ( $option.length > 0 ) {
          locationSelect.value = locationData.store_code;
          locationSelect.dispatchEvent( new Event( 'change' ) );
        }
      } );

      const pickupInput = document.querySelector( 'input#selected_store' );
      if ( pickupInput ) {
        pickupInput.value = locationData.store_code;
      }

      return locationData;
    } catch ( error ) {
      console.error( 'Error getting preferred location:', error );
      return null;
    }
  }

  function selectStoredLocation( locationData ) {
    if ( !locationData || !locationData.id ) return;

    const locationRadio = document.querySelector( `input[name="location"][value="${locationData.id}"]` );

    if ( locationRadio ) {
      locationRadio.checked = true;
    } else {
      const input = document.querySelector( `[name="${config.formId}"]` );
      if ( input ) {
        input.value = locationData.zip;
        searchLocations( input.value );
      }
    }
  }

  function handleFormSubmit( event ) {
    event.preventDefault();

    const form = event.target;
    const input = form.querySelector( `[name="${config.formId}"]` );

    if ( !input || !input.value.trim() ) {
      console.warn( 'Please enter a ZIP code, city, or state' );
      return;
    }

    setLoadingState( true );
    searchLocations( input.value.trim() );
  }

  function handleUseMyLocation( event ) {
    if ( event ) {
      event.preventDefault();
    }

    if ( !navigator.geolocation ) {
      getLocationByIp();
      return;
    }

    setLoadingState( true );

    navigator.geolocation.getCurrentPosition(
        ( position ) => {
          reverseGeocode( position.coords.latitude, position.coords.longitude )
              .then( ( zipCode ) => {
                if ( zipCode ) {
                  const input = document.querySelector( `[name="${config.formId}"]` );
                  if ( input ) {
                    input.value = zipCode;
                  }

                  searchLocations( zipCode );
                } else {
                  setLoadingState( false );
                  console.warn( 'Could not determine your location' );
                }
              } )
              .catch( ( error ) => {
                setLoadingState( false );
                getLocationByIp();
              } );
        },
        ( error ) => {
          setLoadingState( false );
          getLocationByIp();
          console.error( 'Outer Error getting location:', error.message );
        },
    );
  }

  function reverseGeocode( lat, lng ) {
    return fetch( config.userLocationEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-WP-Nonce': config.nonce,
      },
      body: JSON.stringify( {
        latitude: lat,
        longitude: lng,
      } ),
    } )
        .then( ( response ) => {
          if ( !response.ok ) {
            throw new Error( 'Network response was not ok' );
          }
          return response.json();
        } )
        .then( ( data ) => {
          return data.success ? data.zip : null;
        } )
        .catch( ( error ) => {
          console.error( 'Error finding nearest zip code:', error );
          throw error;
        } );
  }

  function searchLocations( input ) {
    const data = {
      input: input,
      limit: config.limit,
      radius: config.radius,
    };

    fetch( config.endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-WP-Nonce': config.nonce,
      },
      body: JSON.stringify( data ),
    } )
        .then( async ( response ) => {
          if ( !response.ok ) {
            const errorData = await response.json();
            throw new Error( errorData.message || 'An error occurred while searching locations' );
          }
          return response.json();
        } )
        .then( ( data ) => {
          handleSearchResults( data );

          setTimeout( () => {
            if ( document.querySelector( '#flyout__find-a-store input[name="location"]:checked' ) ) return;

            const firstLocationRadio = document.querySelector( '#flyout__find-a-store input[name="location"]' );
            if ( firstLocationRadio ) {
              firstLocationRadio.checked = true;
              savePreferredLocation( firstLocationRadio.value );
            }
          }, 100 );
        } )
        .catch( ( error ) => {
          console.error( 'Search locations error:', error );
          displayError( error.message || 'An error occurred while searching locations' );
        } )
        .finally( () => {
          setLoadingState( false );
        } );
  }

  function handleSearchResults( data ) {
    if ( !data.success ) {
      displayError( data.message || 'No locations found. Please try a different search.' );
      return;
    }

    const locationsList = document.querySelector( '#flyout__find-a-store ul' );
    if ( locationsList ) {
      locationsList.innerHTML = '';

      data.locations.forEach( ( location ) => {
        const listItem = createLocationListItem( location );
        locationsList.appendChild( listItem );
      } );
    }
  }

  function formatHours( hours ) {
    if ( !hours ) return 'Hours not available';

    const today = new Date().toLocaleDateString( 'en-US', {weekday: 'long'} ).toLowerCase(); const todayHours = hours[today];
    if ( !todayHours || !todayHours.open || !todayHours.close ) {
      return 'Closed today';
    }

    return `Today: ${todayHours.open} - ${todayHours.close}`;
  }

  function formatPhone( phone ) {
    if ( !phone ) return '';
    const cleaned = ( '' + phone ).replace( /\D/g, '' );
    const match = cleaned.match( /^(\d{3})(\d{3})(\d{4})$/ );

    if ( match ) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }

    return phone;
  }

  function displayError( message ) {
    const locationsList = document.querySelector( '#flyout__find-a-store ul' );
    if ( locationsList ) {
      locationsList.innerHTML = `
        <li class="p-5 my-0 border-b border-gray-100">
          <p class="text-red-500 paragraph-default">${message}</p>
        </li>
      `;
    }
  }

  function setLoadingState( isLoading ) {
    const form = document.querySelector( `form:has([name="${config.formId}"])` );
    if ( !form ) return;

    const submitButton = form.querySelector( 'button[type="submit"]' );
    if ( submitButton ) {
      submitButton.disabled = isLoading;
      if ( !isLoading ) {
        submitButton.style.opacity = null;
      }
      submitButton.querySelector( 'span' ).innerText = isLoading ? 'Searching...' : 'Search';
    }
  }

  function createLocationListItem( location ) {
    const li = document.createElement( 'li' );
    li.className = 'flex gap-3 p-5 my-0 border-b border-gray-100';
    li.dataset.id = location.id;
    li.dataset.store_id = location.store_id;
    li.dataset.city = location.city;
    li.dataset.state = location.state;
    li.dataset.zip = location.zip;
    li.dataset.address = location.street;

    const hours = formatHours( location.hours );

    const storedLocation = getPreferredLocation();
    const isSelected = storedLocation && storedLocation.id === location.id.toString();
    const hoursClass = hours.includes( 'Closed' ) ? 'text-red-500' : 'text-brand-green';

    li.innerHTML = `
      <div class="filter-inputs" style="--input-padding: 0">
        <input id="location-picker-${location.id}" name="location" type="radio" value="${location.id}" ${isSelected ? 'checked' : ''}>
        <label for="location-picker-${location.id}" class="relative top-[5px] label block size-5"></label>
      </div>
      <div class="w-full">
        <label class="flex items-center gap-3 mb-3" for="location-picker-${location.id}">
          <p class="font-semibold paragraph-default">
            ${location.city}, ${location.state}
          </p>
          <p class="text-gray-300 paragraph-small">
            ${location.distance} miles
          </p>
        </label>
        <p class="mb-3 paragraph-small ${hoursClass}">
          ${hours}
        </p>
        <p class="mb-3 text-gray-500 paragraph-small">
          <span class="block">
            ${location.street}
          </span>
          <span class="block">
            ${location.city}, ${location.state} ${location.zip}
          </span>
        </p>
        <div class="flex items-center justify-between w-full">
          <a href="tel:${location.phone}" class="paragraph-small hover:underline btn-">
            ${formatPhone( location.phone )}
          </a>
          <a class="underline paragraph-small text-brand-navy hover:text-brand-blue btn-" href="${location.url}">
            Learn More
            <span class="sr-only">about our ${location.city} location</span>
          </a>
        </div>
      </div>
    `;

    return li;
  }

  return {
    init: init,
    search: searchLocations,
    getPreferredLocation: getPreferredLocation,
  };
} )();

export default LocationSearch;
